<template>
  <v-container fluid class="pa-0 ma-0" >
    <v-row no-gutters class="pa-0 ma-0" align="end" justify="end" align-content="stretch">
      <!-- justify="space-around" align-content="space-around" -->

      <!-- Left - Logo/Form -->
      <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12" align-self="center" >
        <v-row no-gutters class="pa-0 ma-0" align="center" justify="space-around" >
          <v-col xs="7" sm="9" md="9" lg="10" xl="7" class="pa-0 ma-0" >

            <v-container class="pa-0 ma-0 pb-8">
              <!-- Logo -->
              <v-row class="pa-0 ma-0 pa-8" justify="space-around">
                <v-col class="pa-0 ma-0" >
                  <v-img :src="theme.logoImgUrl" max-height="250" max-width="500"></v-img>
                </v-col>
              </v-row>
              <!-- Form -->
              <v-row align="center" class="pa-0 ma-0">
                <login-form />
              </v-row>
              <!-- Aprenda a criar o cadastro -->
              <v-row class="pt-5">
                <v-btn text x-small block @click="showVideo = true">
                  Aprenda a criar seu cadastro
                  <v-icon right dark>mdi-help-circle-outline</v-icon>
                </v-btn>
              </v-row>
            </v-container>

          </v-col>
        </v-row>
      </v-col>

      <!-- Right - Image -->
      <v-col v-if="$vuetify.breakpoint.mdAndUp" xs="3" sm="6" md="6" lg="6" xl="5" cols="6"
        class="pa-0 ma-0" align-self="end">
        <v-img :src="theme.loginImgUrl" position="center right" contain max-height="800"/>
      </v-col>

    </v-row>

    <v-dialog v-model="showVideo" :max-width="videoWidth" >
      <v-card>
        <v-toolbar dense flat>
          <v-spacer></v-spacer>
          <v-btn text icon @click="showVideo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- <v-card-text class="pa-0"> -->
          <vue-vimeo-player v-if="showVideo" :video-id="'340252629'"
            :player-width="videoWidth" :player-height="videoHeight" class="pa-0 ma-0" />
        <!-- </v-card-text> -->
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player';
import LoginForm from '@/components/login/LoginForm';

export default {
  data: () => ({
    showVideo: false,
    windowHeight: 0,
  }),
  mounted() {
    this.windowHeight = window.innerHeight;
  },
  computed: {
    videoWidth() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 280;
      }

      if (this.$vuetify.breakpoint.name === 'sm' || this.$vuetify.breakpoint.name === 'md') {
        return 650;
      }

      if (this.$vuetify.breakpoint.name === 'lg') {
        return 800;
      }

      return 1000;
    },
    videoHeight() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return 190;
      }

      if (this.$vuetify.breakpoint.name === 'sm' || this.$vuetify.breakpoint.name === 'md') {
        return 325;
      }

      if (this.$vuetify.breakpoint.name === 'lg') {
        return 400;
      }

      return 500;
    },
    theme() {
      return this.$store.getters['poweredBy/theme'];
    },
    onResize() {
      this.windowHeight = window.innerHeight;
    },
  },
  methods: {
    recoverPassword() {
      this.$router.push({ path: '/recover-password' });
    },
  },
  components: {
    LoginForm,
    vueVimeoPlayer,
  },
};
</script>
